<template>
  <v-footer
    app
    v-if="$store.getters.userConsent.analytics == undefined"
    id="trackingFooter"
  >
    <v-row no-gutters>
      <v-col offset-md="1" sm="12" md="8" cols="12">
        <div class="cookies-header">{{ $t('cookie.information_footer_header') }}</div>
        <div class="cookie-text">{{ $t('cookie.information_footer_text') }}</div>
        <v-btn text class="link-button" @click="linkDataProtection()">{{ $t('cookie.information_footer_link_dataprotection') }}</v-btn>
        <CookieSettingsDialog></CookieSettingsDialog>
      </v-col>
      <v-col offset-md="1" sm="12" md="2" cols="12">
        <v-btn
          outlined
          @click="agreeCookies()"
          class="agree-button"
          id="agree"
          >{{ $t('cookie.information_footer_link_agree') }}</v-btn
        >
      </v-col>
    </v-row>
  </v-footer>
</template>

<style scoped>
.link-button {
  font-weight: bold;
  text-decoration: underline;
  padding-left: 0px !important;
}

.cookies-header {
  height: 36px;
  width: 180px;
  color: #182128;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 36px;
  white-space: nowrap;
}

.agree-button {
  background-color: #005abb;
  border-radius: 5px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 10px;
  text-align: center;
  padding: 30px 25px 30px 25px !important;
  margin-top: 35px;
}

.cookie-text {
  color: #182128;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 18px;
}
</style>

<script>
import CookieSettingsDialog from "./CookieSettingsDialog";

export default {
  components: {
    CookieSettingsDialog,
  },
  data: () => ({
    sheet: false,
  }),
  methods: {
    agreeCookies: function() {
      this.sheet = false;
      this.$store.dispatch("activateAllOnlineTracking");
    },
    linkDataProtection: function() {
      window.location.href =
        "https://www.schott.com/german/company/legal3.html";
    },
  },
};
</script>
